<div class="modal__actions">
    <button class="button button--secondary" (click)="cancel()">Cancel</button>
    <button class="button button--secondary f-left" (click)="back()" *ngIf="showBack()">Back</button>
    <button class="button" (click)="save()" [disabled]="!isStepCompleted()" [class.button--disabled]="!isStepCompleted()">{{getForwardButtonLabel()}}</button>
</div>